var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m1 = require("@/static/hotActivity/local.png")

  var l0 = _vm.__map(_vm.hotActivityList, function(item, index) {
    var m0 = _vm.$getImg(item.coverImages)
    return {
      $orig: _vm.__get_orig(item),
      m0: m0
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m1: m1,
        l0: l0
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }